import { useDroppable } from '@dnd-kit/react';
import { FC } from 'react';
import { cn } from '@/shared/lib';

type Props = {
  /** Место промежутка в сетке — им же диаграмма опознаётся отпущенной именно здесь */
  id: string;
};

/**
 * Промежуток между строками сетки: диаграмма, отпущенная в него, открывает собой новую строку.
 *
 * Промежуток занимает сам зазор между строками и на раскладку не влияет: собственную высоту он
 * целиком возвращает сетке отрицательными полями, поэтому строка под него не отводится и строки
 * стоят так же, как на применённом дашборде. Зазор он при этом перекрывает с запасом — целиться в
 * полосу шире, чем сам зазор. Указателя он не перехватывает — иначе перекрытые им края соседних
 * диаграмм перестали бы принимать нажатия; перетаскивание же ловится не событиями элемента, а его
 * местом на странице.
 */
export const ChartRowGap: FC<Props> = ({ id }) => {
  const { ref, isDropTarget } = useDroppable({ id });

  return (
    <div ref={ref} aria-hidden className="pointer-events-none -my-3 flex h-6 items-center lg:col-span-60">
      {/* Полоса показывает, что диаграмма встанет новой строкой, — но только пока над ней ведут */}
      <div className={cn('h-0.5 w-full rounded-full', isDropTarget ? 'bg-primary' : 'bg-transparent')} />
    </div>
  );
};
